import { useEffect } from 'react';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { View, Image, StyleSheet } from 'react-native';

/**
 * Root index — immediately redirects to /gate which handles all auth/onboarding routing.
 * Kept minimal to avoid race conditions with AuthProvider not being ready yet.
 */
export default function IndexPage() {
  const router = useRouter();
  const params = useLocalSearchParams();

  useEffect(() => {
    const gymCode = params.gym;
    if (gymCode) {
      router.replace(`/gate?gym=${gymCode}` as any);
    } else {
      router.replace('/gate');
    }
  }, []);

  return (
    <View style={styles.container}>
      <Image
        source={require('@/assets/images/duel-logo.png')}
        style={styles.logo}
        resizeMode="contain"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#030303',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: 160,
    height: 160,
  },
});
